const semanticClassNames = {
  root: 'horizontal-menu',
  menuItemWrapper: 'horizontal-menu__item',
  menuItemLabel: 'horizontal-menu__item-label',
} as const;

export default semanticClassNames;
